import { useEffect, useState } from "react";

// Trả về true khi media query khớp. Dùng để đổi bố cục theo bề ngang màn hình
// mà vẫn giữ được lối viết style bằng JS của cả dự án (không cần file CSS riêng).
export function useMediaQuery(query) {
    const getMatch = () =>
        typeof window !== "undefined" && typeof window.matchMedia === "function"
            ? window.matchMedia(query).matches
            : false;

    const [matches, setMatches] = useState(getMatch);

    useEffect(() => {
        const mql = window.matchMedia(query);
        const onChange = () => setMatches(mql.matches);

        onChange();
        mql.addEventListener("change", onChange);
        return () => mql.removeEventListener("change", onChange);
    }, [query]);

    return matches;
}
